module.exports = __webpack_public_path__ + "static/img/15.5e27418.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/sp/15.png
// module id = p9PK
// module chunks = 0